.tableScroll {
    overflow-x: auto;
    width: 100%;
}

.loadMore {
    align-self: center;
}

.expirationCell {
    align-items: center;
    gap: var(--pesticide-licenses-card-expiration-cell-gap);
}
